import { Nullable } from '@kts-front/types';
import { Center, Loader } from '@mantine/core';
import * as React from 'react';

import ErrorLayout from 'components/shared/ErrorLayout/ErrorLayout';

type GlobalLoaderProps = {
  error?: Nullable<string>;
};

const GlobalLoader = ({ error }: GlobalLoaderProps): React.ReactElement<GlobalLoaderProps> => {
  return (
    <Center>{error ? <ErrorLayout error={error} isNotFound={false} withNavigateToMain={false} /> : <Loader />}</Center>
  );
};

export default GlobalLoader;
